import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2, ArrowRight } from "lucide-react";
import { adminLogin, setToken, getToken } from "../api";
import Logo from "../components/Logo";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (getToken()) navigate("/admin");
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { token } = await adminLogin(password);
      setToken(token);
      navigate("/admin");
    } catch (err) {
      setError("Nieprawidłowe hasło. Spróbuj ponownie.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Logo />
        </div>
        <form onSubmit={submit} className="glass-card rounded-3xl p-8 sm:p-10">
          <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-white/10 border border-white/20">
            <Lock className="h-6 w-6 text-white" />
          </div>
          <h1 className="text-center font-display text-2xl font-bold uppercase tracking-wide text-white">
            Panel Administratora
          </h1>
          <p className="mt-2 text-center text-sm text-white/55">
            Zaloguj się, aby zarządzać wiadomościami i ogłoszeniami.
          </p>

          <div className="mt-8">
            <label className="mb-2 block text-sm font-medium text-white/75">Hasło</label>
            <input
              type="password"
              autoFocus
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-sm text-white placeholder:text-white/35 outline-none backdrop-blur-md transition-colors focus:border-white/45"
            />
          </div>

          {error && <p className="mt-4 text-sm text-red-400">{error}</p>}

          <button
            type="submit"
            disabled={loading || !password}
            className="glass-btn-solid glass-btn mt-7 w-full py-3.5 text-sm font-semibold disabled:opacity-50"
          >
            {loading ? (
              <><Loader2 className="h-4 w-4 animate-spin" /> Logowanie...</>
            ) : (
              <>Zaloguj się <ArrowRight className="h-4 w-4" /></>
            )}
          </button>
        </form>

        <button
          onClick={() => navigate("/")}
          className="mt-6 mx-auto block text-sm text-white/45 hover:text-white transition-colors"
        >
          ← Powrót do strony
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;
